import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { AvailablePackedBinsContainerModel, PackingOrderPackedBinsContainerModel } from '../../../../../../models/aggregates/erp/stock';
import { ApiVisa, Pagination, PagingResponseModel } from '../../shared';

@Injectable({ providedIn: 'root' })
export class PackingOrderPackedBinsService extends BaseApiTemplateService<PackingOrderPackedBinsContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "bl_fi_packing_order_packed_bins/" + Core2Config.BACKOFFICE_EP_SUFFIX;

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX +
      "bl_fi_packing_order_packed_bins/" + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX +
      "bl_fi_packing_order_packed_bins/" + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.httpClient = http;
  }

  getAvailablePacked(pagination: Pagination, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria = this.apiUrl + '/available?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<AvailablePackedBinsContainerModel>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }
}